export const TTS_CHINA_VOICE_SOURCE = [
  {
    id: 'Chinese (Mandarin)_Reliable_Executive',
    name: '沉稳高管',
    lang: 'zh',
    urlPath: '151111-kuCORajWVSgeIR8H.mp3',
    description: '低沉厚实',
  },
  {
    id: 'Chinese (Mandarin)_Mature_Woman',
    name: '傲娇御姐',
    lang: 'zh',
    urlPath: '151114-scNPHIXWla9PY66t.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Chinese (Mandarin)_Unrestrained_Young_Man',
    name: '不羁青年',
    lang: 'zh',
    urlPath: '151112-LFgb15w960gYHewo.mp3',
    description: '低沉磁性',
  },
  {
    id: 'Arrogant_Miss',
    name: '嚣张小姐',
    lang: 'zh',
    urlPath: '151115-gmNfSpVkiyBJ2oZ4.mp3',
    description: '娇俏明亮',
  },
  {
    id: 'Robot_Armor',
    name: '机械战甲',
    lang: 'zh',
    urlPath: '151119-UsJcRUyy4w8kLBZw.mp3',
    description: '金属质感',
  },
  {
    id: 'Chinese (Mandarin)_Kind-hearted_Antie',
    name: '热心大婶',
    lang: 'zh',
    urlPath: '151117-ZzFpLzi24V9ju9hP.mp3',
    description: '高昂明亮',
  },
  {
    id: 'Chinese (Mandarin)_Humorous_Elder',
    name: '搞笑大爷',
    lang: 'zh',
    urlPath: '151122-bIc7kEaNBy9IY11Y.mp3',
    description: '沧桑醇厚',
  },
  {
    id: 'Chinese (Mandarin)_Gentleman',
    name: '温润男声',
    lang: 'zh',
    urlPath: '151123-RPGTjDgHx8VR7bV9.mp3',
    description: '温润清亮',
  },
  {
    id: 'Chinese (Mandarin)_Warm_Bestie',
    name: '温暖闺蜜',
    lang: 'zh',
    urlPath: '151125-AVlArJDMQvnqbDhY.mp3',
    description: '温柔清亮',
  },
  {
    id: 'Chinese (Mandarin)_Male_Announcer',
    name: '播报男声',
    lang: 'zh',
    urlPath: '151141-L2Qqm7qoID1KDnsd.mp3',
    description: '清澈干净',
  },
  {
    id: 'Chinese (Mandarin)_Sweet_Lady',
    name: '甜美女声',
    lang: 'zh',
    urlPath: '151128-mYmeChXHKaMMIvVl.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Chinese (Mandarin)_Southern_Young_Man',
    name: '南方小哥',
    lang: 'zh',
    urlPath: '151131-ABwr5gUlTLJUZ6q6.mp3',
    description: '温润细腻',
  },
  {
    id: 'Chinese (Mandarin)_Wise_Women',
    name: '阅历姐姐',
    lang: 'zh',
    urlPath: '151134-D6UAbnJfH0xWwrRG.mp3',
    description: '温润厚实',
  },
  {
    id: 'Chinese (Mandarin)_Gentle_Youth',
    name: '温润青年',
    lang: 'zh',
    urlPath: '151136-0iuxLslgzdPEA5tp.mp3',
    description: '清亮干净',
  },
  {
    id: 'Chinese (Mandarin)_Warm_Girl',
    name: '温暖少女',
    lang: 'zh',
    urlPath: '151140-NQoBUAIsZUTGLd27.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Chinese (Mandarin)_Kind-hearted_Elder',
    name: '花甲奶奶',
    lang: 'zh',
    urlPath: '151143-knTKZYaIsk9kt0ck.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Chinese (Mandarin)_Cute_Spirit',
    name: '憨憨萌兽',
    lang: 'zh',
    urlPath: '151145-zD4A8g2tRn7KDKur.mp3',
    description: '软萌稚嫩',
  },
  {
    id: 'Chinese (Mandarin)_Radio_Host',
    name: '电台男主播',
    lang: 'zh',
    urlPath: '151146-NohvCDigB6BP8U6x.mp3',
    description: '清亮明快',
  },
  {
    id: 'Chinese (Mandarin)_Lyrical_Voice',
    name: '抒情男声',
    lang: 'zh',
    urlPath: '151148-d72hqOqYsRogtPed.mp3',
    description: '温润醇厚',
  },
  {
    id: 'Chinese (Mandarin)_Straightforward_Boy',
    name: '率真弟弟',
    lang: 'zh',
    urlPath: '151150-VPQOOjQKpjCLEnvQ.mp3',
    description: '明朗干净',
  },
  {
    id: 'Chinese (Mandarin)_Sincere_Adult',
    name: '真诚青年',
    lang: 'zh',
    urlPath: '151151-qeikBkqzxKL5GKlM.mp3',
    description: '清澈干净',
  },
  {
    id: 'Chinese (Mandarin)_Gentle_Senior',
    name: '温柔学姐',
    lang: 'zh',
    urlPath: '151153-rsgJWCHF8EjHgZnA.mp3',
    description: '温婉柔和',
  },
  {
    id: 'Chinese (Mandarin)_Stubborn_Friend',
    name: '嘴硬竹马',
    lang: 'zh',
    urlPath: '151126-lkYX7foVGp47x7Eg.mp3',
    description: '清朗温暖',
  },
  {
    id: 'Chinese (Mandarin)_Crisp_Girl',
    name: '清脆少女',
    lang: 'zh',
    urlPath: '151154-U0boVSfEoXYdYwM5.mp3',
    description: '清脆甜美',
  },
  {
    id: 'Chinese (Mandarin)_Pure-hearted_Boy',
    name: '清澈邻家弟弟',
    lang: 'zh',
    urlPath: '151156-F41sbFfQTFNHhMhr.mp3',
    description: '清澈干净',
  },
  {
    id: 'Chinese (Mandarin)_Soft_Girl',
    name: '软软女孩',
    lang: 'zh',
    urlPath: '151257-u1aHN9RSmXygfHL3.mp3',
    description: '甜美软糯',
  },
  {
    id: 'Cantonese_ProfessionalHost（F)',
    name: '专业女主持',
    lang: 'zhYue',
    urlPath: '153508-0e61E6MvtrvhDzBj.mp3',
    description: '清晰明亮',
  },
  {
    id: 'Cantonese_GentleLady',
    name: '温柔女声',
    lang: 'zhYue',
    urlPath: '153512-aefWIYiWHq3gMLiH.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Cantonese_CuteGirl',
    name: '可爱女孩',
    lang: 'zhYue',
    urlPath: '153518-O6chfLyMDCwM2Cm3.mp3',
    description: '稚嫩甜美',
  },
  {
    id: 'Cantonese_KindWoman',
    name: '善良女声',
    lang: 'zhYue',
    urlPath: '153521-W1ElnkbfBFJxo5ZC.mp3',
    description: '略带沙哑',
  },
  { id: 'English_Trustworthy_Man', name: 'Trustworthy Man', lang: 'en', urlPath: '155731-Unmza6ndcLGaIZgT.mp3' },
  {
    id: 'English_Graceful_Lady',
    name: 'Graceful Lady',
    lang: 'en',
    urlPath: '152658-WJkGrvC4bovkTSRU.mp3',
    description: '温润',
  },
  {
    id: 'English_Aussie_Bloke',
    name: 'Aussie Bloke',
    lang: 'en',
    urlPath: '151101-lmtZK3jHs5rBfO8C.mp3',
    description: '明亮且富有质感',
  },
  {
    id: 'English_Diligent_Man',
    name: 'Diligent Man',
    lang: 'en',
    urlPath: '152656-3W64UIVCXZ1AlJeM.mp3',
    description: '清脆明亮',
  },
  {
    id: 'English_Gentle-voiced_man',
    name: 'Gentle-voiced Man',
    lang: 'en',
    urlPath: '152653-a50pVBtP5e5hDpGf.mp3',
    description: '醇厚深沉',
  },
  {
    id: 'Japanese_IntellectualSenior',
    name: 'Intellectual Senior',
    lang: 'ja',
    urlPath: '151054-5xRFlBKcLUjUjTsn.mp3',
    description: '清澈柔和',
  },
  {
    id: 'Japanese_DecisivePrincess',
    name: 'Decisive Princess',
    lang: 'ja',
    urlPath: '151058-aEzxZPxOZt8XbjHA.mp3',
    description: '清脆透亮',
  },
  {
    id: 'Japanese_LoyalKnight',
    name: 'Loyal Knight',
    lang: 'ja',
    urlPath: '152447-2TjFp1zzAHb9Gzoa.mp3',
    description: '清冷孤傲',
  },
  {
    id: 'Japanese_DominantMan',
    name: 'Dominant Man',
    lang: 'ja',
    urlPath: '152450-GT7H6Ptvc75cEI9x.mp3',
    description: '质感冷冽',
  },
  {
    id: 'Japanese_SeriousCommander',
    name: 'Serious Commander',
    lang: 'ja',
    urlPath: '152453-7DI3VtU7Q7ATVHXl.mp3',
    description: '温润清冷',
  },
  {
    id: 'Japanese_ColdQueen',
    name: 'Cold Queen',
    lang: 'ja',
    urlPath: '152456-HuU8ENbGU2m9t6Gc.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Japanese_DependableWoman',
    name: 'Dependable Woman',
    lang: 'ja',
    urlPath: '152459-8hI8yP0cwK16y8jN.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Japanese_GentleButler',
    name: 'Gentle Butler',
    lang: 'ja',
    urlPath: '152501-7va4dGEv3PoTAvfK.mp3',
    description: '磁性且略带慵懒',
  },
  {
    id: 'Japanese_KindLady',
    name: 'Kind Lady',
    lang: 'ja',
    urlPath: '152502-tjVqOaACki9c94Q7.mp3',
    description: '温柔妩媚',
  },
  {
    id: 'Japanese_CalmLady',
    name: 'Calm Lady',
    lang: 'ja',
    urlPath: '152504-EwG9UncaXLc0yIau.mp3',
    description: '清冷优雅',
  },
  {
    id: 'Japanese_OptimisticYouth',
    name: 'Optimistic Youth',
    lang: 'ja',
    urlPath: '152505-HQEqaOiTXEPh1v7K.mp3',
    description: '清爽明快',
  },
  {
    id: 'Japanese_GenerousIzakayaOwner',
    name: 'Generous Izakaya Owner',
    lang: 'ja',
    urlPath: '152508-hXgYr9r7Qw6mnE8Z.mp3',
    description: '豪爽沙哑',
  },
  {
    id: 'Japanese_SportyStudent',
    name: 'Sporty Student',
    lang: 'ja',
    urlPath: '152509-daDH0H3TWyLgMhmn.mp3',
    description: '清亮朝气',
  },
  {
    id: 'Japanese_InnocentBoy',
    name: 'Innocent Boy',
    lang: 'ja',
    urlPath: '152511-9yG9isxbPQ9h59Lt.mp3',
    description: '清澈纯净',
  },
  {
    id: 'Japanese_GracefulMaiden',
    name: 'Graceful Maiden',
    lang: 'ja',
    urlPath: '152512-O8ZZFGLPAkoyxrLs.mp3',
    description: '清澈柔和',
  },
  {
    id: 'Korean_SweetGirl',
    name: 'Sweet Girl',
    lang: 'ko',
    urlPath: '151336-BvkstX3bIiH2wVbl.mp3',
    description: '清脆甜美',
  },
  {
    id: 'Korean_CheerfulBoyfriend',
    name: 'Cheerful Boyfriend',
    lang: 'ko',
    urlPath: '151338-vWebsTc33EFRGHJA.mp3',
    description: '清亮干净',
  },
  {
    id: 'Korean_EnchantingSister',
    name: 'Enchanting Sister',
    lang: 'ko',
    urlPath: '151340-0qPBbZiXOFCDALA1.mp3',
    description: '极富磁性',
  },
  {
    id: 'Korean_ShyGirl',
    name: 'Shy Girl',
    lang: 'ko',
    urlPath: '151341-ZfvNipzfEy6iT9wF.mp3',
    description: '细腻气声',
  },
  {
    id: 'Korean_ReliableSister',
    name: 'Reliable Sister',
    lang: 'ko',
    urlPath: '151343-YD4H6DgR7xR6BlhI.mp3',
    description: '干练沙哑',
  },
  {
    id: 'Korean_StrictBoss',
    name: 'Strict Boss',
    lang: 'ko',
    urlPath: '151345-QAcryobKGdopSQcJ.mp3',
    description: '清亮透彻',
  },
  {
    id: 'Korean_SassyGirl',
    name: 'Sassy Girl',
    lang: 'ko',
    urlPath: '151346-9VI8YOmAlFHv656R.mp3',
    description: '甜美娇俏',
  },
  {
    id: 'Korean_ChildhoodFriendGirl',
    name: 'Childhood Friend Girl',
    lang: 'ko',
    urlPath: '151348-UGghICHUCSKwAyrd.mp3',
    description: '明亮沙哑',
  },
  {
    id: 'Korean_PlayboyCharmer',
    name: 'Playboy Charmer',
    lang: 'ko',
    urlPath: '151350-RedD99wRgCG7JENt.mp3',
    description: '慵懒磁性',
  },
  {
    id: 'Korean_ElegantPrincess',
    name: 'Elegant Princess',
    lang: 'ko',
    urlPath: '151352-pEHkviTh8N0LsYlg.mp3',
    description: '清冷高贵',
  },
  {
    id: 'Korean_BraveFemaleWarrior',
    name: 'Brave Female Warrior',
    lang: 'ko',
    urlPath: '151353-u1QbYgBHLLHy0drO.mp3',
    description: '清亮凛冽',
  },
  {
    id: 'Korean_BraveYouth',
    name: 'Brave Youth',
    lang: 'ko',
    urlPath: '151355-w4hgjWhA02nDQTd5.mp3',
    description: '清朗明快',
  },
  {
    id: 'Korean_CalmLady',
    name: 'Calm Lady',
    lang: 'ko',
    urlPath: '151357-xqH0AZdYPhuEvyAG.mp3',
    description: '清冷优雅',
  },
  {
    id: 'Korean_EnthusiasticTeen',
    name: 'Enthusiastic Teen',
    lang: 'ko',
    urlPath: '151358-SE4wXQ4zdBleIuco.mp3',
    description: '清亮高亢',
  },
  {
    id: 'Korean_SoothingLady',
    name: 'Soothing Lady',
    lang: 'ko',
    urlPath: '151401-aEBSwrTjHk56Yx9N.mp3',
    description: '温柔慵懒',
  },
  {
    id: 'Korean_IntellectualSenior',
    name: 'Intellectual Senior',
    lang: 'ko',
    urlPath: '151402-vy5BTv7ejlKmh79e.mp3',
    description: '温润清澈',
  },
  {
    id: 'Korean_LonelyWarrior',
    name: 'Lonely Warrior',
    lang: 'ko',
    urlPath: '151404-ytkg2dSoe4AWLyNe.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Korean_MatureLady',
    name: 'Mature Lady',
    lang: 'ko',
    urlPath: '151405-8fqP4OjMEcc1ebP9.mp3',
    description: '冷艳锐利',
  },
  {
    id: 'Korean_InnocentBoy',
    name: 'Innocent Boy',
    lang: 'ko',
    urlPath: '151407-MRHk05hfLK9homLM.mp3',
    description: '清澈稚嫩',
  },
  {
    id: 'Korean_CharmingSister',
    name: 'Charming Sister',
    lang: 'ko',
    urlPath: '151509-CDYikRztiMfCxltI.mp3',
    description: '低沉略带沙哑',
  },
  {
    id: 'Korean_AthleticStudent',
    name: 'Athletic Student',
    lang: 'ko',
    urlPath: '151511-jXa22e7tVUWDx1v7.mp3',
    description: '明亮高亢',
  },
  {
    id: 'Korean_BraveAdventurer',
    name: 'Brave Adventurer',
    lang: 'ko',
    urlPath: '151513-PiwsD2zatmRE2FUb.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_CalmGentleman',
    name: 'Calm Gentleman',
    lang: 'ko',
    urlPath: '151515-Tc470Y6US9xBlQmo.mp3',
    description: '低沉优雅',
  },
  {
    id: 'Korean_WiseElf',
    name: 'Wise Elf',
    lang: 'ko',
    urlPath: '151516-UWjctPYe0q6nub5L.mp3',
    description: '温柔细腻',
  },
  {
    id: 'Korean_CheerfulCoolJunior',
    name: 'Cheerful Cool Junior',
    lang: 'ko',
    urlPath: '151518-8wph7SOm9dUe595J.mp3',
    description: '清亮爽朗',
  },
  {
    id: 'Korean_DecisiveQueen',
    name: 'Decisive Queen',
    lang: 'ko',
    urlPath: '151520-ECvLON3Wc4CaAL68.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_ColdYoungMan',
    name: 'Cold Young Man',
    lang: 'ko',
    urlPath: '151522-R3tghkZG76C2CnGS.mp3',
    description: '清冷清澈',
  },
  {
    id: 'Korean_MysteriousGirl',
    name: 'Mysterious Girl',
    lang: 'ko',
    urlPath: '151524-lJCq4JbLlpAl9Jeo.mp3',
    description: '甜美高亢',
  },
  {
    id: 'Korean_QuirkyGirl',
    name: 'Quirky Girl',
    lang: 'ko',
    urlPath: '151525-oekISEZKAtiPT3qT.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_ConsiderateSenior',
    name: 'Considerate Senior',
    lang: 'ko',
    urlPath: '151527-KlLNvodmon6m3PW1.mp3',
    description: '温暖厚实',
  },
  {
    id: 'Korean_CheerfulLittleSister',
    name: 'Cheerful Little Sister',
    lang: 'ko',
    urlPath: '151529-oQNvDGH94ef53zId.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_DominantMan',
    name: 'Dominant Man',
    lang: 'ko',
    urlPath: '151531-LjD0oKPytFUXbamo.mp3',
    description: '冷峻低沉',
  },
  {
    id: 'Korean_AirheadedGirl',
    name: 'Airheaded Girl',
    lang: 'ko',
    urlPath: '151532-EhMJVA8jrgHEoECC.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_ReliableYouth',
    name: 'Reliable Youth',
    lang: 'ko',
    urlPath: '151534-L2YtehiccAWxIamu.mp3',
    description: '干净纯粹',
  },
  {
    id: 'Korean_FriendlyBigSister',
    name: 'Friendly Big Sister',
    lang: 'ko',
    urlPath: '151536-nEuHLZMrfiNyFH5J.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Korean_GentleBoss',
    name: 'Gentle Boss',
    lang: 'ko',
    urlPath: '151538-jv9vxeclNgeryvdw.mp3',
    description: '阴冷沙哑',
  },
  {
    id: 'Korean_ColdGirl',
    name: 'Cold Girl',
    lang: 'ko',
    urlPath: '151540-6Bd1UWFOQXoepj23.mp3',
    description: '轻柔慵懒',
  },
  {
    id: 'Korean_HaughtyLady',
    name: 'Haughty Lady',
    lang: 'ko',
    urlPath: '151542-ivug7WB2FuEhB12o.mp3',
    description: '通透澄澈',
  },
  {
    id: 'Korean_CharmingElderSister',
    name: 'Charming Elder Sister',
    lang: 'ko',
    urlPath: '151543-8GXPI9XdjwT9y87G.mp3',
    description: '华丽优雅',
  },
  {
    id: 'Korean_IntellectualMan',
    name: 'Intellectual Man',
    lang: 'ko',
    urlPath: '151546-3EikWKDej9uOPyrT.mp3',
    description: '低沉醇厚',
  },
  {
    id: 'Korean_CaringWoman',
    name: 'Caring Woman',
    lang: 'ko',
    urlPath: '151548-MrbNkK9XmcZEupUs.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_WiseTeacher',
    name: 'Wise Teacher',
    lang: 'ko',
    urlPath: '151549-XmWpKKA3EbX7ZQdk.mp3',
    description: '清亮明快',
  },
  {
    id: 'Korean_ConfidentBoss',
    name: 'Confident Boss',
    lang: 'ko',
    urlPath: '151551-dgM6iEumpZ07AsdF.mp3',
    description: '沙哑磁性',
  },
  {
    id: 'Korean_AthleticGirl',
    name: 'Athletic Girl',
    lang: 'ko',
    urlPath: '151553-T9yHnv0HOWtBDuOy.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_PossessiveMan',
    name: 'Possessive Man',
    lang: 'ko',
    urlPath: '151554-8YZECSNxFIjlR64d.mp3',
    description: '冷冽富有磁性',
  },
  {
    id: 'Korean_GentleWoman',
    name: 'Gentle Woman',
    lang: 'ko',
    urlPath: '151556-kmPhqVj7l4YkiLPx.mp3',
    description: '清澈温润',
  },
  {
    id: 'Korean_CockyGuy',
    name: 'Cocky Guy',
    lang: 'ko',
    urlPath: '151557-6XUO8v3n3iFzZFrc.mp3',
    description: '中气十足',
  },
  {
    id: 'Korean_ThoughtfulWoman',
    name: 'Thoughtful Woman',
    lang: 'ko',
    urlPath: '151559-BtGUQautv2yWRvFl.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Korean_OptimisticYouth',
    name: 'Optimistic Youth',
    lang: 'ko',
    urlPath: '151601-RqFBKWgz9m56rhKg.mp3',
    description: '清亮',
  },
  {
    id: 'Spanish_SereneWoman',
    name: 'Serene Woman',
    lang: 'es',
    urlPath: '151756-3zB1lBG1dqYPeGah.mp3',
    description: '明亮清脆',
  },
  {
    id: 'Spanish_MaturePartner',
    name: 'Mature Partner',
    lang: 'es',
    urlPath: '151759-AY9869YjdXpARn5a.mp3',
    description: '粗犷沙哑',
  },
  {
    id: 'Spanish_CaptivatingStoryteller',
    name: 'Captivating Storyteller',
    lang: 'es',
    urlPath: '151800-bdHppY4cwVOHgx5a.mp3',
    description: '深沉厚重',
  },
  {
    id: 'Spanish_Narrator',
    name: 'Narrator',
    lang: 'es',
    urlPath: '151802-mseUoJup0v9My9We.mp3',
    description: '热情洋溢',
  },
  {
    id: 'Spanish_WiseScholar',
    name: 'Wise Scholar',
    lang: 'es',
    urlPath: '151804-CoddGncfNo04vfob.mp3',
    description: '清亮质朴',
  },
  {
    id: 'Spanish_Kind-heartedGirl',
    name: 'Kind-hearted Girl',
    lang: 'es',
    urlPath: '151805-JOaimVc0mSJQSj6J.mp3',
    description: '甜美清亮',
  },
  {
    id: 'Spanish_DeterminedManager',
    name: 'Determined Manager',
    lang: 'es',
    urlPath: '151807-jdFhZuwKcS9YlJht.mp3',
    description: '锐利坚定',
  },
  {
    id: 'Spanish_BossyLeader',
    name: 'Bossy Leader',
    lang: 'es',
    urlPath: '151808-QnDMRiSFYOsCuHFx.mp3',
    description: '沙哑粗砺',
  },
  {
    id: 'Spanish_ReservedYoungMan',
    name: 'Reserved Young Man',
    lang: 'es',
    urlPath: '151810-joBxlbr3HIwkgmEG.mp3',
    description: '温润清澈',
  },
  {
    id: 'Spanish_ConfidentWoman',
    name: 'Confident Woman',
    lang: 'es',
    urlPath: '151811-byS3VNjJyROcpmfS.mp3',
    description: '明亮清晰',
  },
  {
    id: 'Spanish_ThoughtfulMan',
    name: 'Thoughtful Man',
    lang: 'es',
    urlPath: '151812-JiZn2qOerlmo4e2V.mp3',
    description: '温润磁性',
  },
  {
    id: 'Spanish_Strong-WilledBoy',
    name: 'Strong-willed Boy',
    lang: 'es',
    urlPath: '151814-KnV4pGDo6Ue1ss8l.mp3',
    description: '清亮坚定',
  },
  {
    id: 'Spanish_SophisticatedLady',
    name: 'Sophisticated Lady',
    lang: 'es',
    urlPath: '151815-iSRGpnKiVaUSkQJY.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Spanish_RationalMan',
    name: 'Rational Man',
    lang: 'es',
    urlPath: '151817-hUBhBfWQxW9BhkbC.mp3',
    description: '低沉浑厚',
  },
  {
    id: 'Spanish_AnimeCharacter',
    name: 'Anime Character',
    lang: 'es',
    urlPath: '151819-6FquBLu7Q2PAHY7O.mp3',
    description: '粗犷沙哑',
  },
  {
    id: 'Spanish_Deep-tonedMan',
    name: 'Deep-toned Man',
    lang: 'es',
    urlPath: '151821-4Nm4dLoJ4qQBzLag.mp3',
    description: '浑厚',
  },
  {
    id: 'Spanish_Fussyhostess',
    name: 'Fussy hostess',
    lang: 'es',
    urlPath: '151823-VU1wNvF7wKSXsrHE.mp3',
    description: '尖锐高亢',
  },
  {
    id: 'Spanish_SincereTeen',
    name: 'Sincere Teen',
    lang: 'es',
    urlPath: '151825-zBaxEbJdXHKlNiXe.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Spanish_FrankLady',
    name: 'Frank Lady',
    lang: 'es',
    urlPath: '151827-0XSGVYKiJVyCwdnp.mp3',
    description: '明亮尖锐',
  },
  {
    id: 'Spanish_Comedian',
    name: 'Comedian',
    lang: 'es',
    urlPath: '151829-eqC4jtjuK9rTvmKP.mp3',
    description: '高亢明快',
  },
  {
    id: 'Spanish_Debator',
    name: 'Debator',
    lang: 'es',
    urlPath: '151831-qtgYSvvpumk8DV30.mp3',
    description: '沙哑粗砺',
  },
  {
    id: 'Spanish_ToughBoss',
    name: 'Tough Boss',
    lang: 'es',
    urlPath: '151833-EjU0JYuHXYolFJ8i.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Spanish_Wiselady',
    name: 'Wise Lady',
    lang: 'es',
    urlPath: '151835-sNlgY7gAbGD1Dv4c.mp3',
    description: '清亮优雅',
  },
  {
    id: 'Spanish_Steadymentor',
    name: 'Steady Mentor',
    lang: 'es',
    urlPath: '151836-TsDKcIHKheXZeHJO.mp3',
    description: '粗砺沙哑',
  },
  {
    id: 'Spanish_Jovialman',
    name: 'Jovial Man',
    lang: 'es',
    urlPath: '151838-4q2pKfDC2wgZRkAz.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Spanish_SantaClaus',
    name: 'Santa Claus',
    lang: 'es',
    urlPath: '151840-Bf2FSxLyVbvUqLeU.mp3',
    description: '浑厚洪亮',
  },
  {
    id: 'Spanish_Rudolph',
    name: 'Rudolph',
    lang: 'es',
    urlPath: '151841-w5Kdw71xz4VxVpRw.mp3',
    description: '稚嫩鼻音',
  },
  {
    id: 'Spanish_Intonategirl',
    name: 'Intonate Girl',
    lang: 'es',
    urlPath: '151843-BaDf6CqaMkVjJC4J.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Spanish_Arnold',
    name: 'Arnold',
    lang: 'es',
    urlPath: '151845-b349omu9vWC0LlXA.mp3',
    description: '低沉沙哑',
  },
  { id: 'Spanish_Ghost', name: 'Ghost', lang: 'es', urlPath: '151846-au7I2H2oo39VAI3L.mp3', description: '粗犷沙哑' },
  {
    id: 'Spanish_HumorousElder',
    name: 'Humorous Elder',
    lang: 'es',
    urlPath: '151848-q2D0vWYVAwGXEUUz.mp3',
    description: '沙哑滑稽',
  },
  {
    id: 'Spanish_EnergeticBoy',
    name: 'Energetic Boy',
    lang: 'es',
    urlPath: '151950-rIaR9Im33IY2Hzh7.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Spanish_WhimsicalGirl',
    name: 'Whimsical Girl',
    lang: 'es',
    urlPath: '151952-J3BA1lvPLmLnPcBR.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Spanish_StrictBoss',
    name: 'Strict Boss',
    lang: 'es',
    urlPath: '151954-3fzGvF6vgckvEGIz.mp3',
    description: '硬朗有力',
  },
  {
    id: 'Spanish_ReliableMan',
    name: 'Reliable Man',
    lang: 'es',
    urlPath: '151955-H0OIn5Tz2xEfbJOl.mp3',
    description: '低沉浑厚',
  },
  {
    id: 'Spanish_SereneElder',
    name: 'Serene Elder',
    lang: 'es',
    urlPath: '151957-JzRSqM8PsYQai1ZU.mp3',
    description: '苍老沙哑',
  },
  {
    id: 'Spanish_AngryMan',
    name: 'Angry Man',
    lang: 'es',
    urlPath: '151959-goVHMyMGbfrelicx.mp3',
    description: '紧绷高亢',
  },
  {
    id: 'Spanish_AssertiveQueen',
    name: 'Assertive Queen',
    lang: 'es',
    urlPath: '152001-ZJexU8PZvqCWBImq.mp3',
    description: '清亮锐利',
  },
  {
    id: 'Spanish_CaringGirlfriend',
    name: 'Caring Girlfriend',
    lang: 'es',
    urlPath: '152002-73HcOyKcbsuyVi4R.mp3',
    description: '甜美柔和',
  },
  {
    id: 'Spanish_PowerfulSoldier',
    name: 'Powerful Soldier',
    lang: 'es',
    urlPath: '152004-m9DttxiNSXpT15Fw.mp3',
    description: '刚毅有力',
  },
  {
    id: 'Spanish_PassionateWarrior',
    name: 'Passionate Warrior',
    lang: 'es',
    urlPath: '152006-DtmdN6nsvTQPoiZv.mp3',
    description: '清朗',
  },
  {
    id: 'Spanish_ChattyGirl',
    name: 'Chatty Girl',
    lang: 'es',
    urlPath: '152007-e4X0TGJdsHkc3oKc.mp3',
    description: '甜美明亮',
  },
  {
    id: 'Spanish_RomanticHusband',
    name: 'Romantic Husband',
    lang: 'es',
    urlPath: '152009-bl2iAPvT9OAKQHG0.mp3',
    description: '自然松弛',
  },
  {
    id: 'Spanish_CompellingGirl',
    name: 'Compelling Girl',
    lang: 'es',
    urlPath: '152011-g8evItI8DWfACFV1.mp3',
    description: '清亮坚定',
  },
  {
    id: 'Spanish_PowerfulVeteran',
    name: 'Powerful Veteran',
    lang: 'es',
    urlPath: '152012-Qa0zeS2cmMpXybmk.mp3',
    description: '低沉粗砺',
  },
  {
    id: 'Spanish_SensibleManager',
    name: 'Sensible Manager',
    lang: 'es',
    urlPath: '152014-EyJl0S9kakmWKXlT.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Spanish_ThoughtfulLady',
    name: 'Thoughtful Lady',
    lang: 'es',
    urlPath: '152016-tpvUfrasQAfOZDeT.mp3',
    description: '柔和细腻',
  },
  {
    id: 'Portuguese_SentimentalLady',
    name: 'Sentimental Lady',
    lang: 'pt',
    urlPath: '152032-oTlyWSO2mFiAA48e.mp3',
    description: '尖锐明亮',
  },
  {
    id: 'Portuguese_BossyLeader',
    name: 'Bossy Leader',
    lang: 'pt',
    urlPath: '152033-2DHF4lGwMOlsGxcW.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Portuguese_Wiselady',
    name: 'Wise lady',
    lang: 'pt',
    urlPath: '152035-xfNK0UijraoskrtW.mp3',
    description: '清晰明亮',
  },
  {
    id: 'Portuguese_Strong-WilledBoy',
    name: 'Strong-willed Boy',
    lang: 'pt',
    urlPath: '152037-DM11P1h2Z91I0flk.mp3',
    description: '清朗坚定',
  },
  {
    id: 'Portuguese_Deep-VoicedGentleman',
    name: 'Deep-voiced Gentleman',
    lang: 'pt',
    urlPath: '152039-Ab8rdci1fNVJBqbN.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Portuguese_UpsetGirl',
    name: 'Upset Girl',
    lang: 'pt',
    urlPath: '152040-AHUMBD2hQqT2oo5x.mp3',
    description: '轻柔细腻',
  },
  {
    id: 'Portuguese_PassionateWarrior',
    name: 'Passionate Warrior',
    lang: 'pt',
    urlPath: '152042-6IUPfVZuYSQ98kvx.mp3',
    description: '清亮激昂',
  },
  {
    id: 'Portuguese_AnimeCharacter',
    name: 'Anime Character',
    lang: 'pt',
    urlPath: '152044-UUWYORmoFitsNObT.mp3',
    description: '高亢明亮',
  },
  {
    id: 'Portuguese_ConfidentWoman',
    name: 'Confident Woman',
    lang: 'pt',
    urlPath: '152046-Ve5HHb68VWcCzwvf.mp3',
    description: '明亮穿透',
  },
  {
    id: 'Portuguese_AngryMan',
    name: 'Angry Man',
    lang: 'pt',
    urlPath: '152048-FRojmbUivH87gfKO.mp3',
    description: '紧绷且略带沙哑',
  },
  {
    id: 'Portuguese_CaptivatingStoryteller',
    name: 'Captivating Storyteller',
    lang: 'pt',
    urlPath: '152050-MtkPBl15ArXy9HBj.mp3',
    description: '低沉浑厚',
  },
  {
    id: 'Portuguese_Godfather',
    name: 'Godfather',
    lang: 'pt',
    urlPath: '152051-sZxl8VRi0qjPYnSF.mp3',
    description: '沙哑低沉',
  },
  {
    id: 'Portuguese_ReservedYoungMan',
    name: 'Reserved Young Man',
    lang: 'pt',
    urlPath: '152053-zn4ZwNT4kflolpsc.mp3',
    description: '纯净透亮',
  },
  {
    id: 'Portuguese_SmartYoungGirl',
    name: 'Smart Young Girl',
    lang: 'pt',
    urlPath: '152055-ppwo2VdkUzRWYMHe.mp3',
    description: '高昂清脆',
  },
  {
    id: 'Portuguese_Kind-heartedGirl',
    name: 'Kind-hearted Girl',
    lang: 'pt',
    urlPath: '152056-dpKOBRXQi2RC647L.mp3',
    description: '清澈甜美',
  },
  {
    id: 'Portuguese_Pompouslady',
    name: 'Pompous lady',
    lang: 'pt',
    urlPath: '152058-mr0UymFcSgWnanTn.mp3',
    description: '高亢尖锐',
  },
  {
    id: 'Portuguese_Grinch',
    name: 'Grinch',
    lang: 'pt',
    urlPath: '152100-TvljnZEeZe9giiVN.mp3',
    description: '沙哑粗砺',
  },
  {
    id: 'Portuguese_Debator',
    name: 'Debator',
    lang: 'pt',
    urlPath: '152102-KDDGaNYhgG64d5kT.mp3',
    description: '沙哑粗砺',
  },
  {
    id: 'Portuguese_SweetGirl',
    name: 'Sweet Girl',
    lang: 'pt',
    urlPath: '152103-TumN81TnslnTyFPG.mp3',
    description: '甜美娇俏',
  },
  {
    id: 'Portuguese_AttractiveGirl',
    name: 'Attractive Girl',
    lang: 'pt',
    urlPath: '152105-65RVFJPHOjzODNkl.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Portuguese_ThoughtfulMan',
    name: 'Thoughtful Man',
    lang: 'pt',
    urlPath: '152107-twNrkXXyftPhjGNT.mp3',
    description: '清亮干净',
  },
  {
    id: 'Portuguese_PlayfulGirl',
    name: 'Playful Girl',
    lang: 'pt',
    urlPath: '152108-4PJaJR2gmKVPrSdZ.mp3',
    description: '甜美清亮',
  },
  {
    id: 'Portuguese_GorgeousLady',
    name: 'Gorgeous Lady',
    lang: 'pt',
    urlPath: '152210-fRnGt88AfwSqFe8b.mp3',
    description: '妩媚动人',
  },
  {
    id: 'Portuguese_LovelyLady',
    name: 'Lovely Lady',
    lang: 'pt',
    urlPath: '152212-tcb5KNKvjT76kdHt.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Portuguese_SereneWoman',
    name: 'Serene Woman',
    lang: 'pt',
    urlPath: '152214-yVb4e8wV0HH8u24O.mp3',
    description: '明亮清晰',
  },
  {
    id: 'Portuguese_SadTeen',
    name: 'Sad Teen',
    lang: 'pt',
    urlPath: '152216-MNouOE6Fsxtb8lNW.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Portuguese_MaturePartner',
    name: 'Mature Partner',
    lang: 'pt',
    urlPath: '152217-42QdmOf7eRmpSEpL.mp3',
    description: '粗砺沙哑',
  },
  {
    id: 'Portuguese_Comedian',
    name: 'Comedian',
    lang: 'pt',
    urlPath: '152219-Q4t7XMUsZYz613tM.mp3',
    description: '高亢明亮',
  },
  {
    id: 'Portuguese_NaughtySchoolgirl',
    name: 'Naughty Schoolgirl',
    lang: 'pt',
    urlPath: '152221-XREiqNvpF9fKvnUH.mp3',
    description: '清脆甜美',
  },
  {
    id: 'Portuguese_Narrator',
    name: 'Narrator',
    lang: 'pt',
    urlPath: '152223-X6WEEooUnXnfrdx0.mp3',
    description: '温暖亲切',
  },
  {
    id: 'Portuguese_ToughBoss',
    name: 'Tough Boss',
    lang: 'pt',
    urlPath: '152225-nFMBnZZL4Roflz5E.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Portuguese_Fussyhostess',
    name: 'Fussy hostess',
    lang: 'pt',
    urlPath: '152227-2K32w15m0NFBYoZT.mp3',
    description: '尖锐高亢',
  },
  {
    id: 'Portuguese_Dramatist',
    name: 'Dramatist',
    lang: 'pt',
    urlPath: '152229-gLEnhtnx7LkZxUuT.mp3',
    description: '沙哑',
  },
  {
    id: 'Portuguese_Steadymentor',
    name: 'Steady Mentor',
    lang: 'pt',
    urlPath: '152231-h89K3MNnmbqCv33a.mp3',
    description: '沙哑粗犷',
  },
  {
    id: 'Portuguese_Jovialman',
    name: 'Jovial Man',
    lang: 'pt',
    urlPath: '152233-Hjwizah6Nd81Qwac.mp3',
    description: '粗犷且略带沙哑',
  },
  {
    id: 'Portuguese_CharmingQueen',
    name: 'Charming Queen',
    lang: 'pt',
    urlPath: '152235-H49mEmT18IwhufTQ.mp3',
    description: '冷艳磁性',
  },
  {
    id: 'Portuguese_SantaClaus',
    name: 'Santa Claus',
    lang: 'pt',
    urlPath: '152236-V1r2NAvEboTyKSCx.mp3',
    description: '浑厚洪亮',
  },
  {
    id: 'Portuguese_Rudolph',
    name: 'Rudolph',
    lang: 'pt',
    urlPath: '152238-3CNYogNr0Cy4fnbm.mp3',
    description: '鼻音质感',
  },
  {
    id: 'Portuguese_Arnold',
    name: 'Arnold',
    lang: 'pt',
    urlPath: '152240-OnBm3eNlXmQbfJav.mp3',
    description: '浑厚低沉',
  },
  {
    id: 'Portuguese_CharmingSanta',
    name: 'Charming Santa',
    lang: 'pt',
    urlPath: '152242-ua817Bz09nXlKYcX.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Portuguese_CharmingLady',
    name: 'Charming Lady',
    lang: 'pt',
    urlPath: '152440-fUfvBWcpBOxMdRBx.mp3',
    description: '气声饱满',
  },
  {
    id: 'Portuguese_Ghost',
    name: 'Ghost',
    lang: 'pt',
    urlPath: '152244-Ls8e1TTUZ4qleqZJ.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Portuguese_HumorousElder',
    name: 'Humorous Elder',
    lang: 'pt',
    urlPath: '152246-2fZUMW9UE6qGj74b.mp3',
    description: '沙哑颤抖',
  },
  {
    id: 'Portuguese_CalmLeader',
    name: 'Calm Leader',
    lang: 'pt',
    urlPath: '152248-2zUqWOHBdAuL0zQw.mp3',
    description: '低沉粗犷',
  },
  {
    id: 'Portuguese_GentleTeacher',
    name: 'Gentle Teacher',
    lang: 'pt',
    urlPath: '152249-MwCKTNLEsBrzv0iS.mp3',
    description: '声线清澈',
  },
  {
    id: 'Portuguese_EnergeticBoy',
    name: 'Energetic Boy',
    lang: 'pt',
    urlPath: '152251-ReFwilyrqVk1Yq4J.mp3',
    description: '阳光清爽',
  },
  {
    id: 'Portuguese_ReliableMan',
    name: 'Reliable Man',
    lang: 'pt',
    urlPath: '152253-143EwuoLeuEkkQrM.mp3',
    description: '低沉醇厚',
  },
  {
    id: 'Portuguese_SereneElder',
    name: 'Serene Elder',
    lang: 'pt',
    urlPath: '152255-rT7x8FVrGLH4Eerl.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Portuguese_GrimReaper',
    name: 'Grim Reaper',
    lang: 'pt',
    urlPath: '152256-W3OQ7OM4Dpnxe8j7.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Portuguese_AssertiveQueen',
    name: 'Assertive Queen',
    lang: 'pt',
    urlPath: '152258-cRs2hiqXCQ7AsEMF.mp3',
    description: '华丽富有质感',
  },
  {
    id: 'Portuguese_WhimsicalGirl',
    name: 'Whimsical Girl',
    lang: 'pt',
    urlPath: '152259-INTV0r9r31k5VMzb.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Portuguese_StressedLady',
    name: 'Stressed Lady',
    lang: 'pt',
    urlPath: '152301-nXjOkTD7KiPpg6Zx.mp3',
    description: '颤抖且略带气声',
  },
  {
    id: 'Portuguese_FriendlyNeighbor',
    name: 'Friendly Neighbor',
    lang: 'pt',
    urlPath: '152303-uBYdOoohfRqxB93v.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Portuguese_CaringGirlfriend',
    name: 'Caring Girlfriend',
    lang: 'pt',
    urlPath: '152304-4TxWSmqbaMhgdcOF.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Portuguese_PowerfulSoldier',
    name: 'Powerful Soldier',
    lang: 'pt',
    urlPath: '152306-6EumWZ5kc9RLW5JU.mp3',
    description: '沙哑爆发',
  },
  {
    id: 'Portuguese_FascinatingBoy',
    name: 'Fascinating Boy',
    lang: 'pt',
    urlPath: '152308-NV3hzmDfdgZQE0de.mp3',
    description: '明亮',
  },
  {
    id: 'Portuguese_RomanticHusband',
    name: 'Romantic Husband',
    lang: 'pt',
    urlPath: '152310-DLFBoGEnWiPBCYjY.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Portuguese_StrictBoss',
    name: 'Strict Boss',
    lang: 'pt',
    urlPath: '152312-RbC2Nqi3aZ3VUdU7.mp3',
    description: '清晰高亢',
  },
  {
    id: 'Portuguese_InspiringLady',
    name: 'Inspiring Lady',
    lang: 'pt',
    urlPath: '152313-0m8UkEWXhrObA2NQ.mp3',
    description: '清脆甜美',
  },
  {
    id: 'Portuguese_PlayfulSpirit',
    name: 'Playful Spirit',
    lang: 'pt',
    urlPath: '152315-bZgBWdgWed3SWg9O.mp3',
    description: '高亢明亮',
  },
  {
    id: 'Portuguese_ElegantGirl',
    name: 'Elegant Girl',
    lang: 'pt',
    urlPath: '152317-OMpQlYQyu6B4pDlr.mp3',
    description: '声线清脆尖细',
  },
  {
    id: 'Portuguese_CompellingGirl',
    name: 'Compelling Girl',
    lang: 'pt',
    urlPath: '152319-uv0Qz4ZIRUnsKp9i.mp3',
    description: '清晰坚实',
  },
  {
    id: 'Portuguese_PowerfulVeteran',
    name: 'Powerful Veteran',
    lang: 'pt',
    urlPath: '152321-8AOjaxwM9tz8jHYK.mp3',
    description: '粗砺深沉',
  },
  {
    id: 'Portuguese_SensibleManager',
    name: 'Sensible Manager',
    lang: 'pt',
    urlPath: '152322-C5zogW29Nd0IYRad.mp3',
    description: '厚重且略带沙哑',
  },
  {
    id: 'Portuguese_ThoughtfulLady',
    name: 'Thoughtful Lady',
    lang: 'pt',
    urlPath: '152324-JZnZpTOUz13jdS3O.mp3',
    description: '柔和亲切',
  },
  {
    id: 'Portuguese_TheatricalActor',
    name: 'Theatrical Actor',
    lang: 'pt',
    urlPath: '152325-2mlJIi9ISXaX6302.mp3',
    description: '浑厚粗犷',
  },
  {
    id: 'Portuguese_FragileBoy',
    name: 'Fragile Boy',
    lang: 'pt',
    urlPath: '152328-8AOHHOXDzhaTaKHL.mp3',
    description: '带有颤抖气声',
  },
  {
    id: 'Portuguese_ChattyGirl',
    name: 'Chatty Girl',
    lang: 'pt',
    urlPath: '152329-Zdg6gZiyMUEn4neS.mp3',
    description: '甜美明亮',
  },
  {
    id: 'Portuguese_Conscientiousinstructor',
    name: 'Conscientious Instructor',
    lang: 'pt',
    urlPath: '152331-Y1qASvLsmvCXwHDX.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Portuguese_RationalMan',
    name: 'Rational Man',
    lang: 'pt',
    urlPath: '152333-Delxrfy960sIkqb3.mp3',
    description: '低沉浑厚',
  },
  {
    id: 'Portuguese_WiseScholar',
    name: 'Wise Scholar',
    lang: 'pt',
    urlPath: '152335-EUoIJIFMjqdbiB4v.mp3',
    description: '清亮明快',
  },
  {
    id: 'Portuguese_FrankLady',
    name: 'Frank Lady',
    lang: 'pt',
    urlPath: '152437-8xgxXat9oX8HRC7M.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Portuguese_DeterminedManager',
    name: 'Determined Manager',
    lang: 'pt',
    urlPath: '152438-RDVChmwGFedWH1ts.mp3',
    description: '尖锐且充满张力',
  },
  {
    id: 'French_Male_Speech_New',
    name: 'Level-Headed Man',
    lang: 'fr',
    urlPath: '153329-CN0BBqKgvvINBPv4.mp3',
    description: '清晰明朗',
  },
  {
    id: 'French_Female_News Anchor',
    name: 'Patient Female Presenter',
    lang: 'fr',
    urlPath: '153330-NgRHIjmHPMTGm2QF.mp3',
    description: '知性清晰',
  },
  {
    id: 'French_CasualMan',
    name: 'Casual Man',
    lang: 'fr',
    urlPath: '153331-OMiqZOf3FSCTLzZg.mp3',
    description: '温润且富有质感',
  },
  {
    id: 'French_MovieLeadFemale',
    name: 'Movie Lead Female',
    lang: 'fr',
    urlPath: '153333-sO46W302xkujLQGw.mp3',
    description: '清脆明亮',
  },
  {
    id: 'French_FemaleAnchor',
    name: 'Female Anchor',
    lang: 'fr',
    urlPath: '153335-vhBwqt0sWDdHL2DS.mp3',
    description: '略带沙哑',
  },
  {
    id: 'French_MaleNarrator',
    name: 'Male Narrator',
    lang: 'fr',
    urlPath: '153337-TO2dBJxC0JHAbPL7.mp3',
    description: '清澈干净',
  },
  {
    id: 'Indonesian_SweetGirl',
    name: 'Sweet Girl',
    lang: 'id',
    urlPath: '153146-SVuHVrm9cvnnz5qI.mp3',
    description: '高亢明亮',
  },
  {
    id: 'Indonesian_ReservedYoungMan',
    name: 'Reserved Young Man',
    lang: 'id',
    urlPath: '153149-Q0Gxlz2mrAH0xxui.mp3',
    description: '干净清澈',
  },
  {
    id: 'Indonesian_CharmingGirl',
    name: 'Charming Girl',
    lang: 'id',
    urlPath: '153252-OzKyhBYR2b4nPsIk.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Indonesian_CalmWoman',
    name: 'Calm Woman',
    lang: 'id',
    urlPath: '153256-Hoiylbuma8soWbA9.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Indonesian_ConfidentWoman',
    name: 'Confident Woman',
    lang: 'id',
    urlPath: '153259-YzjNibRG4gudlYek.mp3',
    description: '明亮圆润',
  },
  {
    id: 'Indonesian_CaringMan',
    name: 'Caring Man',
    lang: 'id',
    urlPath: '153303-MnxHWUts4eJNYM1N.mp3',
    description: '富有磁性',
  },
  {
    id: 'Indonesian_BossyLeader',
    name: 'Bossy Leader',
    lang: 'id',
    urlPath: '153306-i944eWxxS8LRK7Mh.mp3',
    description: '低沉粗犷',
  },
  {
    id: 'Indonesian_DeterminedBoy',
    name: 'Determined Boy',
    lang: 'id',
    urlPath: '153309-xBBrFg53Gpe14qq2.mp3',
    description: '清亮有力',
  },
  {
    id: 'Indonesian_GentleGirl',
    name: 'Gentle Girl',
    lang: 'id',
    urlPath: '153312-aLOcONGPvlF9KKPT.mp3',
    description: '软糯轻柔',
  },
  {
    id: 'German_FriendlyMan',
    name: 'Friendly Man',
    lang: 'de',
    urlPath: '155631-A9zNgfcPbKq2mACD.mp3',
    description: '轻松自然',
  },
  {
    id: 'German_SweetLady',
    name: 'Sweet Lady',
    lang: 'de',
    urlPath: '155633-nEoXYSCrzL5xWrNX.mp3',
    description: '轻柔细腻',
  },
  {
    id: 'German_PlayfulMan',
    name: 'Playful Man',
    lang: 'de',
    urlPath: '155635-7h1zPTVWZ0xJZXY8.mp3',
    description: '自然清亮',
  },
  {
    id: 'Russian_HandsomeChildhoodFriend',
    name: 'Handsome Childhood Friend',
    lang: 'ru',
    urlPath: '153342-BX8DS9BMOoWiv3yV.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Russian_BrightHeroine',
    name: 'Bright Queen',
    lang: 'ru',
    urlPath: '153343-BgXLEfwKvNh5kOFP.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Russian_AmbitiousWoman',
    name: 'Ambitious Woman',
    lang: 'ru',
    urlPath: '153345-y00pevjK8eXr5qVm.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Russian_ReliableMan',
    name: 'Reliable Man',
    lang: 'ru',
    urlPath: '153346-pXU7Y93rvE07glWo.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Russian_CrazyQueen',
    name: 'Crazy Girl',
    lang: 'ru',
    urlPath: '153348-DQIu5oZPrl8LQE4a.mp3',
    description: '高亢明亮',
  },
  {
    id: 'Russian_PessimisticGirl',
    name: 'Pessimistic Girl',
    lang: 'ru',
    urlPath: '153350-3dwHZvBV9BCdofLW.mp3',
    description: '清冷脆弱',
  },
  {
    id: 'Russian_AttractiveGuy',
    name: 'Attractive Guy',
    lang: 'ru',
    urlPath: '153352-yRPNEtICqo4KAlIF.mp3',
    description: '低沉磁性',
  },
  {
    id: 'Russian_Bad-temperedBoy',
    name: 'Bad-tempered Boy',
    lang: 'ru',
    urlPath: '153353-2Gco7WGxFhK9gsAL.mp3',
    description: '稚嫩清亮',
  },
  {
    id: 'Italian_BraveHeroine',
    name: 'Brave Heroine',
    lang: 'it',
    urlPath: '153355-uqoYYR5ESPShT2iX.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Italian_Narrator',
    name: 'Narrator',
    lang: 'it',
    urlPath: '153356-bV50M6UAamYUwHNJ.mp3',
    description: '低沉浑厚',
  },
  {
    id: 'Italian_WanderingSorcerer',
    name: 'Wandering Sorcerer',
    lang: 'it',
    urlPath: '153358-abQOC4Ur7uBYp1EQ.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Italian_DiligentLeader',
    name: 'Diligent Leader',
    lang: 'it',
    urlPath: '153400-071D3Pxb2Alb9aPj.mp3',
    description: '略带沙哑',
  },
  {
    id: 'Arabic_CalmWoman',
    name: 'Calm Woman',
    lang: 'ar',
    urlPath: '153706-G8SjdPzEMLNIROTg.mp3',
    description: '柔和温润',
  },
  {
    id: 'Arabic_FriendlyGuy',
    name: 'Friendly Guy',
    lang: 'ar',
    urlPath: '153708-2k4GWVKhinvjQwEA.mp3',
    description: '醇厚温暖',
  },
  {
    id: 'Turkish_CalmWoman',
    name: 'Calm Woman',
    lang: 'tr',
    urlPath: '155716-vOncJ0rpcC4IaQNI.mp3',
    description: '柔和质感',
  },
  {
    id: 'Turkish_Trustworthyman',
    name: 'Trustworthy man',
    lang: 'tr',
    urlPath: '155717-6da6xcWrWuMApW54.mp3',
    description: '低沉沙哑',
  },
  {
    id: 'Ukrainian_CalmWoman',
    name: 'Calm Woman',
    lang: 'uk',
    urlPath: '155719-pcxQ2frrGpmqf4Aj.mp3',
    description: '知性温婉',
  },
  {
    id: 'Ukrainian_WiseScholar',
    name: 'Wise Scholar',
    lang: 'uk',
    urlPath: '155720-dmhSht5o1PO64O3F.mp3',
    description: '清亮质朴',
  },
  {
    id: 'Dutch_kindhearted_girl',
    name: 'Kind-hearted girl',
    lang: 'nl',
    urlPath: '153710-WoAyeitnLc2W40Bp.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Dutch_bossy_leader',
    name: 'Bossy leader',
    lang: 'nl',
    urlPath: '153711-aBE6lRH8FclBuPnC.mp3',
    description: '沙哑颗粒感',
  },
  {
    id: 'Vietnamese_kindhearted_girl',
    name: 'Kind-hearted girl',
    lang: 'vi',
    urlPath: '153559-1JHFDtWG9Sz6hbHz.mp3',
    description: '甜美细腻',
  },
  {
    id: 'Thai_male_1_sample8',
    name: 'Serene Man',
    lang: 'th',
    urlPath: '153542-4FfgHHONgoFEi33y.mp3',
    description: '醇厚温润',
  },
  {
    id: 'Thai_male_2_sample2',
    name: 'Friendly Man',
    lang: 'th',
    urlPath: '153545-bignOBvUrsNyo6XL.mp3',
    description: '明亮亲切',
  },
  {
    id: 'Thai_female_1_sample1',
    name: 'Confident Woman',
    lang: 'th',
    urlPath: '153547-tarbDTjDHLDWPA0y.mp3',
    description: '明亮',
  },
  {
    id: 'Thai_female_2_sample2',
    name: 'Energetic Woman',
    lang: 'th',
    urlPath: '153548-P5MSKo0iOgsB99BW.mp3',
    description: '清亮',
  },
  {
    id: 'Polish_male_1_sample4',
    name: 'Male Narrator',
    lang: 'pl',
    urlPath: '153803-cT1aMyeRmIreREDv.mp3',
    description: '沉稳厚实',
  },
  {
    id: 'Polish_male_2_sample3',
    name: 'Male Anchor',
    lang: 'pl',
    urlPath: '153804-jFRV9JB3djBB3B7P.mp3',
    description: '清亮',
  },
  {
    id: 'Polish_female_1_sample1',
    name: 'Calm Woman',
    lang: 'pl',
    urlPath: '153806-IYqhIhIR7kf7Tiks.mp3',
    description: '清晰柔和',
  },
  {
    id: 'Polish_female_2_sample3',
    name: 'Casual Woman',
    lang: 'pl',
    urlPath: '153808-TKfLo81Yy7X6Q5ra.mp3',
    description: '温暖且自然',
  },
  {
    id: 'Romanian_male_1_sample2',
    name: 'Reliable Man',
    lang: 'ro',
    urlPath: '153717-G1O7zOTVx9qNuUhu.mp3',
    description: '沉稳厚实',
  },
  {
    id: 'Romanian_male_2_sample1',
    name: 'Energetic Youth',
    lang: 'ro',
    urlPath: '153719-ITSqJvEvlfLqZKg4.mp3',
    description: '清亮且略带沙哑质感',
  },
  {
    id: 'Romanian_female_1_sample4',
    name: 'Optimistic Youth',
    lang: 'ro',
    urlPath: '153720-cIvDQMx8kz3O4Oqy.mp3',
    description: '清脆明亮',
  },
  {
    id: 'Romanian_female_2_sample1',
    name: 'Gentle Woman',
    lang: 'ro',
    urlPath: '153722-LmZBCys7WWeMPHtD.mp3',
    description: '清亮悦耳',
  },
  {
    id: 'greek_male_1a_v1',
    name: 'Thoughtful Mentor',
    lang: 'el',
    urlPath: '153800-85Vd2fNe1SZVCL6P.mp3',
    description: '清亮亲切',
  },
  {
    id: 'Greek_female_1_sample1',
    name: 'Gentle Lady',
    lang: 'el',
    urlPath: '153758-XCC1oyrGeSdYaV6l.mp3',
    description: '柔和细腻',
  },
  {
    id: 'Greek_female_2_sample3',
    name: 'Girl Next Door',
    lang: 'el',
    urlPath: '153801-PfVh1k10LW4AsdAg.mp3',
    description: '清亮自然',
  },
  {
    id: 'czech_male_1_v1',
    name: 'Assured Presenter',
    lang: 'cs',
    urlPath: '153919-N1BcjNMjgJftsUr0.mp3',
    description: '浑厚有力',
  },
  {
    id: 'czech_female_5_v7',
    name: 'Steadfast Narrator',
    lang: 'cs',
    urlPath: '153921-t7f1dhpgAkDiQCVb.mp3',
    description: '清晰明亮',
  },
  {
    id: 'czech_female_2_v2',
    name: 'Elegant Lady',
    lang: 'cs',
    urlPath: '153923-ZsyUwuxXndjmbgC0.mp3',
    description: '清脆明亮',
  },
  {
    id: 'finnish_male_3_v1',
    name: 'Upbeat Man',
    lang: 'fi',
    urlPath: '153924-Jvp1KKTHG7fsenH9.mp3',
    description: '清亮自然',
  },
  {
    id: 'finnish_male_1_v2',
    name: 'Friendly Boy',
    lang: 'fi',
    urlPath: '153927-RhhM799aIHR6g4YI.mp3',
    description: '明朗亲切',
  },
  {
    id: 'finnish_female_4_v1',
    name: 'Assertive Woman',
    lang: 'fi',
    urlPath: '153926-7iVgihF7mWBs36nn.mp3',
    description: '清脆有力',
  },
  {
    id: 'hindi_male_1_v2',
    name: 'Trustworthy Advisor',
    lang: 'hi',
    urlPath: '155637-5dgBdKtTGKbF2ZM0.mp3',
    description: '厚实',
  },
  {
    id: 'hindi_female_2_v1',
    name: 'Tranquil Woman',
    lang: 'hi',
    urlPath: '155640-etCtSqzkhxT0ldwV.mp3',
    description: '温暖沉静',
  },
  {
    id: 'hindi_female_1_v2',
    name: 'News Anchor',
    lang: 'hi',
    urlPath: '155643-CIE58j1VMB9rhsD4.mp3',
    description: '清晰明亮',
  },
  { id: 'male-qn-qingse', name: '青涩青年音色', lang: 'zh', urlPath: '064810-1Mj4Dje9qVs5xHAj.mp3' },
  { id: 'male-qn-jingying', name: '精英青年音色', lang: 'zh', urlPath: '064814-ggLRp0JuZ7tWxn5W.mp3' },
  { id: 'male-qn-badao', name: '霸道青年音色', lang: 'zh', urlPath: '064817-QU5qWRRjMe1RIn1L.mp3' },
  { id: 'male-qn-daxuesheng', name: '青年大学生音色', lang: 'zh', urlPath: '064821-YUlwpWJ8jOcYAxk0.mp3' },
  { id: 'female-shaonv', name: '少女音色', lang: 'zh', urlPath: '064823-etdt1Q40WHuRP4tK.mp3' },
  { id: 'female-yujie', name: '御姐音色', lang: 'zh', urlPath: '064826-90aS0ps9A9UsyGKO.mp3' },
  { id: 'female-chengshu', name: '成熟女性音色', lang: 'zh', urlPath: '064829-C7ZJQbsWSh6SyYlD.mp3' },
  { id: 'female-tianmei', name: '甜美女性音色', lang: 'zh', urlPath: '064832-8RwQauBOlfBLKfwn.mp3' },
  { id: 'male-qn-qingse-jingpin', name: '青涩青年音色-beta', lang: 'zh', urlPath: '064836-AAOV2aj16Cp2IOoV.mp3' },
  { id: 'male-qn-jingying-jingpin', name: '精英青年音色-beta', lang: 'zh', urlPath: '064839-3U7OH8931uOCslDH.mp3' },
  { id: 'male-qn-badao-jingpin', name: '霸道青年音色-beta', lang: 'zh', urlPath: '064841-zKbOtb0wJ7Bv6FbX.mp3' },
  {
    id: 'male-qn-daxuesheng-jingpin',
    name: '青年大学生音色-beta',
    lang: 'zh',
    urlPath: '064844-cNgC21aE2GAa0M0Q.mp3',
  },
  { id: 'female-shaonv-jingpin', name: '少女音色-beta', lang: 'zh', urlPath: '064847-6spyuLXOFyV6NgrR.mp3' },
  { id: 'female-yujie-jingpin', name: '御姐音色-beta', lang: 'zh', urlPath: '064850-4Nm7xdteqGkFpztj.mp3' },
  { id: 'female-chengshu-jingpin', name: '成熟女性音色-beta', lang: 'zh', urlPath: '064852-8XSznA481hl9mq9I.mp3' },
  { id: 'female-tianmei-jingpin', name: '甜美女性音色-beta', lang: 'zh', urlPath: '064855-oNgdBLMi8SyFoDRY.mp3' },
  { id: 'clever_boy', name: '聪明男童', lang: 'zh', urlPath: '064858-zgeFuf9aXqNaqXga.mp3' },
  { id: 'cute_boy', name: '可爱男童', lang: 'zh', urlPath: '064902-2w8fqTtUFR6fBofC.mp3' },
  { id: 'lovely_girl', name: '萌萌女童', lang: 'zh', urlPath: '064905-rwkwzSxBXBLkn4U7.mp3' },
  { id: 'cartoon_pig', name: '卡通猪小琪', lang: 'zh', urlPath: '064908-nh0iGUGro7EgTm2x.mp3' },
  { id: 'bingjiao_didi', name: '病娇弟弟', lang: 'zh', urlPath: '064911-spbMrscfkpk24OCy.mp3' },
  { id: 'junlang_nanyou', name: '俊朗男友', lang: 'zh', urlPath: '064914-mmWffokVDxzRH3mr.mp3' },
  { id: 'chunzhen_xuedi', name: '纯真学弟', lang: 'zh', urlPath: '064916-BSErA9gTkRVVrRo1.mp3' },
  { id: 'lengdan_xiongzhang', name: '冷淡学长', lang: 'zh', urlPath: '064919-u3xT9FUEQ43pDddL.mp3' },
  { id: 'badao_shaoye', name: '霸道少爷', lang: 'zh', urlPath: '064922-O9DYEO2b6MZsr49h.mp3' },
  { id: 'tianxin_xiaoling', name: '甜心小玲', lang: 'zh', urlPath: '064924-CUntGZngBG55uoo6.mp3' },
  { id: 'qiaopi_mengmei', name: '俏皮萌妹', lang: 'zh', urlPath: '064927-IKnm6N6ZO0DMh5Az.mp3' },
  { id: 'wumei_yujie', name: '妩媚御姐', lang: 'zh', urlPath: '064930-6B5HTRKHMyqoUNGw.mp3' },
  { id: 'diadia_xuemei', name: '嗲嗲学妹', lang: 'zh', urlPath: '064933-6Fvyp44pBvwmH4ar.mp3' },
  { id: 'danya_xuejie', name: '淡雅学姐', lang: 'zh', urlPath: '064936-SLNz5RtBIJDFmF8K.mp3' },
  { id: 'Chinese (Mandarin)_News_Anchor', name: '新闻女声', lang: 'zh', urlPath: '064938-xPftMmpj0n1jni7S.mp3' },
  {
    id: 'Chinese (Mandarin)_HK_Flight_Attendant',
    name: '港普空姐',
    lang: 'zh',
    urlPath: '064941-p4KgS9OqimislDbD.mp3',
  },
  { id: 'Cantonese_ProfessionalHost（M)', name: '专业男主持', lang: 'zhYue', urlPath: '064943-JNbBwgn2GDWUIkO6.mp3' },
  { id: 'Cantonese_PlayfulMan', name: '活泼男声', lang: 'zhYue', urlPath: '064946-BMDg4lnThoFJyugw.mp3' },
  { id: 'Santa_Claus', name: 'Santa Claus', lang: 'en', urlPath: '064949-yUtn6ZXNsA8EDM0u.mp3' },
  { id: 'Grinch', name: 'Grinch', lang: 'en', urlPath: '064952-hxdcm5o0i9V8vh65.mp3' },
  { id: 'Rudolph', name: 'Rudolph', lang: 'en', urlPath: '064954-5wtJ1hD1teqS8hUP.mp3' },
  { id: 'Arnold', name: 'Arnold', lang: 'en', urlPath: '064957-AohYXeXf802oJ1Ia.mp3' },
  { id: 'Charming_Santa', name: 'Charming Santa', lang: 'en', urlPath: '065001-0aCzNafMDdbBUKVN.mp3' },
  { id: 'Charming_Lady', name: 'Charming Lady', lang: 'en', urlPath: '065004-AR2u7AiXMeYETP6i.mp3' },
  { id: 'Sweet_Girl', name: 'Sweet Girl', lang: 'en', urlPath: '065007-ZM2lOtgINjndKbfI.mp3' },
  { id: 'Cute_Elf', name: 'Cute Elf', lang: 'en', urlPath: '065010-ybX4sWKx8rI9cbWW.mp3' },
  { id: 'Attractive_Girl', name: 'Attractive Girl', lang: 'en', urlPath: '065012-VwWOwm1Bh57DtiyC.mp3' },
  { id: 'Serene_Woman', name: 'Serene Woman', lang: 'en', urlPath: '065015-o4nvKYkeu8tMAYVv.mp3' },
  { id: 'Boyan_new_platform', name: '绅士青年', lang: 'zh', urlPath: 'Boyan_new_platform-807fdeb6.mp3' },
  {
    id: 'Chinese (Mandarin)_BashfulGirl',
    name: '害羞少女',
    lang: 'zh',
    urlPath: 'Chinese__Mandarin__BashfulGirl-97a2f1af.mp3',
  },
  {
    id: 'Chinese (Mandarin)_ExplorativeGirl',
    name: '探索少女',
    lang: 'zh',
    urlPath: 'Chinese__Mandarin__ExplorativeGirl-a864d166.mp3',
  },
  {
    id: 'Chinese (Mandarin)_IntellectualGirl',
    name: '睿智少女',
    lang: 'zh',
    urlPath: 'Chinese__Mandarin__IntellectualGirl-f3486a49.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Laid_BackGirl',
    name: '慵懒少女',
    lang: 'zh',
    urlPath: 'Chinese__Mandarin__Laid_BackGirl-092ff445.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Warm-HeartedAunt',
    name: '慈爱阿姨',
    lang: 'zh',
    urlPath: 'Chinese__Mandarin__Warm_HeartedAunt-3568a3f0.mp3',
  },
  {
    id: 'Chinese (Mandarin)_Warm_HeartedGirl',
    name: '善良少女',
    lang: 'zh',
    urlPath: 'Chinese__Mandarin__Warm_HeartedGirl-9d747ecf.mp3',
  },
  {
    id: 'English_Deep-VoicedGentleman',
    name: '深沉男声',
    lang: 'en',
    urlPath: 'English_Deep_VoicedGentleman-cfb9be30.mp3',
  },
  { id: 'English_LovelyGirl', name: '甜甜女童', lang: 'en', urlPath: 'English_LovelyGirl-ecd27a7d.mp3' },
  {
    id: 'English_PassionateWarrior',
    name: '热血青年',
    lang: 'en',
    urlPath: 'English_PassionateWarrior-16312abb.mp3',
  },
  { id: 'ai_xndl_sf2_02', name: '睿智长者', lang: 'zh', urlPath: 'last2-6a481578.mp3' },
  { id: 'calm_story1', name: '沉稳老者', lang: 'en', urlPath: 'last4-200b2418.mp3' },
  { id: 'uk_oldman3', name: '资深领袖', lang: 'en', urlPath: 'last5-155aecc0.mp3' },
];
